import { Box } from '@mui/material';
import React from 'react';

import { useMenuContext } from '../../ContextState/useMenuContext';
import { FavoritesDisplayGrid } from '../../Favorites/FavoritesDisplayGrid';

import { DATA_TEST } from '../../enums';
import { handleArrowDownToMoveFocus } from '../../utils/keyboardNavUtils';

import { BackNavigation } from '../Components/BackNavigation';

export const MobileFavoritesMenu: React.FC = () => {
  const { setShowFavoritesSubmenu, favoritesRefs } = useMenuContext();

  return (
    <>
      <BackNavigation
        onClick={() => {
          setShowFavoritesSubmenu(false);
        }}
        handleArrowDownKey={(e: React.KeyboardEvent) => {
          e.preventDefault();
          e.stopPropagation();
          handleArrowDownToMoveFocus(e.key, favoritesRefs?.[0]?.[0]?.current);
        }}
        title={'Favorites'}
      />
      <Box sx={{ px: 4, pb: 2 }} data-test={DATA_TEST.mobile_favorites_container}>
        <FavoritesDisplayGrid />
      </Box>
    </>
  );
};
